import EventTile from 'components/TrackmanEvents/EventTile/EventTile';
import EventTileSkeleton from 'components/TrackmanEvents/EventTileSkeleton/EventTileSkeleton';
import NoUpcomingEvents from '../NoUpcomingEvents/NoUpcomingEvents';
import Subtitle from 'components/TextComps/Subtitle';
import { observer } from 'mobx-react-lite';
import { useStores } from 'index';
import { useTranslation } from 'react-i18next';

export const UpcomingEvents = observer(() => {
  const tes = useStores().trackmanEventsStore;
  const { t } = useTranslation();

  return (
    <div className='events-subpage'>
      <div className='page-heading'>
        <Subtitle>
          <>{t('UpcomingEvents', { ns: 'trackmanEvents' })}</>
        </Subtitle>
      </div>
      {tes.upcomingEventsList.length ? (
        <div className='events-list'>
          {tes.upcomingEventsList.map((event, i: number) => {
            return !event.id ? (
              <EventTileSkeleton key={`${event.title}+${i}-skeleton`} delay={i * 50} />
            ) : (
              <EventTile key={`${event.title}+${i}`} eventItem={event} />
            );
          })}
        </div>
      ) : (
        <NoUpcomingEvents />
      )}
    </div>
  );
});

export default UpcomingEvents;
